var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCampaigns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#002240",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 7.55555C16 6.89916 15.6403 6.33222 15.1111 6.02444V1.77805C15.1111 1.535 14.9172 0.888885 14.2222 0.888885C14.0244 0.888885 13.8281 0.954997 13.6672 1.08389L11.3053 2.97361C10.1189 3.92194 8.62944 4.44444 7.11111 4.44444H1.77778C0.795833 4.44444 0 5.24027 0 6.22222V8.88889C0 9.87083 0.795833 10.6667 1.77778 10.6667H2.71389C2.67528 10.9578 2.65333 11.2539 2.65333 11.5556C2.65333 12.6603 2.91056 13.7042 3.36333 14.6372C3.5075 14.9342 3.82222 15.1111 4.15222 15.1111H6.21556C6.93917 15.1111 7.37361 14.2822 6.935 13.7067C6.47944 13.1089 6.20861 12.3633 6.20861 11.5556C6.20861 11.2469 6.25361 10.9503 6.33111 10.6667H7.11111C8.62944 10.6667 10.1189 11.1892 11.305 12.1375L13.6669 14.0272C13.8245 14.1533 14.0202 14.222 14.2219 14.2222C14.9142 14.2222 15.1108 13.5894 15.1108 13.3333V9.08694C15.6403 8.77889 16 8.21194 16 7.55555ZM13.3333 11.4839L12.4153 10.7494C10.9153 9.54944 9.03111 8.88889 7.11111 8.88889V6.22222C9.03111 6.22222 10.9153 5.56166 12.4153 4.36166L13.3333 3.62722V11.4839Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaigns);
export default __webpack_public_path__ + "static/media/campaigns.21dee2501dd6eccad55806446328e17d.svg";
export { ForwardRef as ReactComponent };